<template>

  <div>

    <Popup :showThis="isOpen" :title="popupText" :definition="popupDefinition"  @click="isOpen=false"/>

    <div class="grid-container toePage">

      <div class="toe-left">

        <div class="introText" @click="isOpen=true; popupText='TOE ANGLE'; popupDefinition=toeContent.definitionPopup">
          <p>The <span class="redText">toe angle</span> is the most significant factor in extending the life of your tires, maintaining good handling and sustaining fuel economy.<span class="icon-information"></span></p>
        </div>

        <div class="carDiagramToe">
          <div class="toe-road">

          <div class="car">
            <img src="../assets/toeCarOutlines.svg">
          </div>

          <div class="frontComponents">
            <img src="../assets/toeFrontEndComponents.svg">
          </div>

          <div class="frontTires">
            <!--Left Mask-->
            <div :class="
            frontSliderValue == 0 ? 'tireMask toe leftTires most toe-left-front' :
            frontSliderValue <= 20 ? 'tireMask toe leftTires toe-left-front' :
            frontSliderValue <= 39 ? 'tireMask toe leftTires toe-left-front' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'tireMask toe leftTires toe-left-front-right' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'tireMask toe leftTires toe-left-front-right' :
            frontSliderValue == 100 ? 'tireMask toe leftTires most toe-left-front-right' :
            null"
            :style="
            frontSliderValue == 0 ? 'transform: rotate(-7deg) scaleX(-1)' :
            frontSliderValue <= 20 ? 'transform: rotate(-3deg) scaleX(-1)' :
            frontSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'transform: rotate(2deg)' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'transform: rotate(3deg)' :
            frontSliderValue == 100 ? 'transform: rotate(7deg)' :
            null"></div>

            <!--Left Tire-->
            <img class="tire leftTires" :class="frontSliderValue == 1 ? 'left-pressure-2' : frontSliderValue == 2 ? 'left-pressure-1' : frontSliderValue == 4 ? 'right-pressure-1' : frontSliderValue == 5 ? 'right-pressure-2' : null"
            :src="
            frontSliderValue == 0 ? toeContent.toe4 :
            frontSliderValue <= 20 ? toeContent.toe3 :
            frontSliderValue <= 39 ? toeContent.toe2 :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? toeContent.tireImage :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? toeContent.toe2 :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? toeContent.toe3 :
            frontSliderValue == 100 ? toeContent.toe4 : null"
            :style="
            frontSliderValue == 0 ? 'transform: rotate(-7deg)' :
            frontSliderValue <= 20 ? 'transform: rotate(-3deg)' :
            frontSliderValue <= 39 ? 'transform: rotate(-2deg)' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'transform: rotate(2deg) scaleX(-1)' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'transform: rotate(3deg) scaleX(-1)' :
            frontSliderValue == 100 ? 'transform: rotate(7deg) scaleX(-1)' :
            null">

            <!--Right Mask-->
            <div :class="
            frontSliderValue == 0 ? 'tireMask toe rightTires most toe-right-front' :
            frontSliderValue <= 20 ? 'tireMask toe rightTires toe-right-front' :
            frontSliderValue <= 39 ? 'tireMask toe rightTires toe-right-front' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'tireMask toe rightTires toe-right-front-right' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'tireMask toe rightTires toe-right-front-right' :
            frontSliderValue == 100 ? 'tireMask toe rightTires most toe-right-front-right' :
            null"
            :style="
            frontSliderValue == 0 ? 'transform: rotate(7deg)' :
            frontSliderValue <= 20 ? 'transform: rotate(3deg)' :
            frontSliderValue <= 39 ? 'transform: rotate(2deg)' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'transform: rotate(-2deg) scaleX(-1)' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'transform: rotate(-3deg) scaleX(-1)' :
            frontSliderValue == 100 ? 'transform: rotate(-7deg) scaleX(-1)' :
            null"></div>

            <!--Right Tire-->
            <img class="tire rightTires" :class="frontSliderValue == 1 ? 'left-pressure-2' : frontSliderValue == 2 ? 'left-pressure-1' : frontSliderValue == 4 ? 'right-pressure-1' : frontSliderValue == 5 ? 'right-pressure-2' : null"
            :src="
            frontSliderValue == 0 ? toeContent.toe4 :
            frontSliderValue <= 20 ? toeContent.toe3 :
            frontSliderValue <= 39 ? toeContent.toe2 :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? toeContent.tireImage :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? toeContent.toe2 :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? toeContent.toe3 :
            frontSliderValue == 100 ? toeContent.toe4 : null"
            :style="
            frontSliderValue == 0 ? 'transform: rotate(7deg) scaleX(-1)' :
            frontSliderValue <= 20 ? 'transform: rotate(3deg) scaleX(-1)' :
            frontSliderValue <= 39 ? 'transform: rotate(2deg) scaleX(-1)' :
            frontSliderValue >= 40 && frontSliderValue <= 60 ? null :
            frontSliderValue >= 61 && frontSliderValue <= 80 ? 'transform: rotate(-2deg)' :
            frontSliderValue >= 81 && frontSliderValue <= 99 ? 'transform: rotate(-3deg)' :
            frontSliderValue == 100 ? 'transform: rotate(-7deg)' :
            null">
          </div>

          <div class="rearTires">
            <!--Left Mask-->
            <div :class="
            rearSliderValue == 0 ? 'tireMask toe leftTires most toe-left-front' :
            rearSliderValue <= 20 ? 'tireMask toe leftTires toe-left-front' :
            rearSliderValue <= 39 ? 'tireMask toe leftTires toe-left-front' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'tireMask toe leftTires toe-left-front-right' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'tireMask toe leftTires toe-left-front-right' :
            rearSliderValue == 100 ? 'tireMask toe leftTires most toe-left-front-right' :
            null"
            :style="
            rearSliderValue == 0 ? 'transform: rotate(-7deg) scaleX(-1)' :
            rearSliderValue <= 20 ? 'transform: rotate(-3deg) scaleX(-1)' :
            rearSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'transform: rotate(2deg)' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'transform: rotate(3deg)' :
            rearSliderValue == 100 ? 'transform: rotate(7deg)' :
            null"></div>

            <!--Left Tire-->
            <img class="tire leftTires" :class="rearSliderValue == 1 ? 'left-pressure-2' : rearSliderValue == 2 ? 'left-pressure-1' : rearSliderValue == 4 ? 'right-pressure-1' : rearSliderValue == 5 ? 'right-pressure-2' : null"
            :src="
            rearSliderValue == 0 ? toeContent.toe4 :
            rearSliderValue <= 20 ? toeContent.toe3 :
            rearSliderValue <= 39 ? toeContent.toe2 :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? toeContent.tireImage :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? toeContent.toe2 :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? toeContent.toe3 :
            rearSliderValue == 100 ? toeContent.toe4 : null"
            :style="
            rearSliderValue == 0 ? 'transform: rotate(-7deg)' :
            rearSliderValue <= 20 ? 'transform: rotate(-3deg)' :
            rearSliderValue <= 39 ? 'transform: rotate(-2deg)' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'transform: rotate(2deg) scaleX(-1)' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'transform: rotate(3deg) scaleX(-1)' :
            rearSliderValue == 100 ? 'transform: rotate(7deg) scaleX(-1)' :
            null">

            <!--Right Mask-->
            <div :class="
            rearSliderValue == 0 ? 'tireMask toe rightTires most toe-right-front' :
            rearSliderValue <= 20 ? 'tireMask toe rightTires toe-right-front' :
            rearSliderValue <= 39 ? 'tireMask toe rightTires toe-right-front' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'tireMask toe rightTires toe-right-front-right' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'tireMask toe rightTires toe-right-front-right' :
            rearSliderValue == 100 ? 'tireMask toe rightTires most toe-right-front-right' :
            null"
            :style="
            rearSliderValue == 0 ? 'transform: rotate(7deg)' :
            rearSliderValue <= 20 ? 'transform: rotate(3deg)' :
            rearSliderValue <= 39 ? 'transform: rotate(2deg)' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'transform: rotate(-2deg) scaleX(-1)' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'transform: rotate(-3deg) scaleX(-1)' :
            rearSliderValue == 100 ? 'transform: rotate(-7deg) scaleX(-1)' :
            null"></div>

            <!--Right Tire-->
            <img class="tire rightTires" :class="rearSliderValue == 1 ? 'left-pressure-2' : rearSliderValue == 2 ? 'left-pressure-1' : rearSliderValue == 4 ? 'right-pressure-1' : rearSliderValue == 5 ? 'right-pressure-2' : null"
            :src="
            rearSliderValue == 0 ? toeContent.toe4 :
            rearSliderValue <= 20 ? toeContent.toe3 :
            rearSliderValue <= 39 ? toeContent.toe2 :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? toeContent.tireImage :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? toeContent.toe2 :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? toeContent.toe3 :
            rearSliderValue == 100 ? toeContent.toe4 : null"
            :style="
            rearSliderValue == 0 ? 'transform: rotate(7deg) scaleX(-1)' :
            rearSliderValue <= 20 ? 'transform: rotate(3deg) scaleX(-1)' :
            rearSliderValue <= 39 ? 'transform: rotate(2deg) scaleX(-1)' :
            rearSliderValue >= 40 && rearSliderValue <= 60 ? null :
            rearSliderValue >= 61 && rearSliderValue <= 80 ? 'transform: rotate(-2deg)' :
            rearSliderValue >= 81 && rearSliderValue <= 99 ? 'transform: rotate(-3deg)' :
            rearSliderValue == 100 ? 'transform: rotate(-7deg)' :
            null">
          </div>

        </div>
        </div>

        <div class="disclaimer">
          <p>{{ toeContent.disclaimer }}</p>
        </div>
      </div>

      <div class="toe-right">
        <div class="header">

          <div>
            <h6>Tread Wear and Fuel Efficiency</h6>
            <p>Tires are scrubbing along the road, reducing your fuel efficiency and tire tread life.</p>
          </div>

          <div class="popupHandler" @click="show =!show">
          <Transition name="slide-fade">
            <div class="lesschwab-popup" v-if="show">
              <p>{{ toeContent.introPopup }}</p>
              <div class="icon-close"></div>
            </div>
          </Transition>
          </div>

          <div class="frontToe">
            <div class="tireWear">
              <div class="toeTreadWear">
                <img :style="frontSliderValue > 60 ? 'transform: scaleX(-1);' : null"
                  :src="
                  frontSliderValue == 0 ? toeContent.toe4 :
                  frontSliderValue <= 20 ? toeContent.toe3 :
                  frontSliderValue <= 39 ? toeContent.toe2 :
                  frontSliderValue >= 40 && frontSliderValue <= 60 ? toeContent.tireImage :
                  frontSliderValue >= 61 && frontSliderValue <= 80 ? toeContent.toe2 :
                  frontSliderValue >= 81 && frontSliderValue <= 99 ? toeContent.toe3 :
                  frontSliderValue == 100 ? toeContent.toe4 : null"
                >
              </div>
              <div class="toeTreadWear">
                <img :style="frontSliderValue > 60 ? null : 'transform: scaleX(-1)'"
                  :src="
                  frontSliderValue == 0 ? toeContent.toe4 :
                  frontSliderValue <= 20 ? toeContent.toe3 :
                  frontSliderValue <= 39 ? toeContent.toe2 :
                  frontSliderValue >= 40 && frontSliderValue <= 60 ? toeContent.tireImage :
                  frontSliderValue >= 61 && frontSliderValue <= 80 ? toeContent.toe2 :
                  frontSliderValue >= 81 && frontSliderValue <= 99 ? toeContent.toe3 :
                  frontSliderValue == 100 ? toeContent.toe4 : null"
                >
              </div>
            </div>
            <div class="lesschwabSliderContainer">
              <input type="range" @change="hidePopup" v-model.number="frontSliderValue" class="slider">
            </div>
            <div class="lesschwabSliderButton">
              <img class="sliderButtons" style="transform: scaleX(-1)" :src=" frontSliderValue >= 40 && frontSliderValue <= 60 ? toeContent.passImage : toeContent.failImage ">
              <div @click="decreaseFront()" class="increaseScale minus background-left left"></div>
              <div @click="increaseFront()" class="increaseScale plus background-right right"></div>
            </div>
            <h6>{{ toeContent.frontSlider }}</h6>
          </div>

          <div class="rearToe">
            <div class="tireWear">
              <div class="toeTreadWear">
                <img :style="rearSliderValue > 60 ? 'transform: scaleX(-1);' : null"
                  :src="
                  rearSliderValue == 0 ? toeContent.toe4 :
                  rearSliderValue <= 20 ? toeContent.toe3 :
                  rearSliderValue <= 39 ? toeContent.toe2 :
                  rearSliderValue >= 40 && rearSliderValue <= 60 ? toeContent.tireImage :
                  rearSliderValue >= 61 && rearSliderValue <= 80 ? toeContent.toe2 :
                  rearSliderValue >= 81 && rearSliderValue <= 99 ? toeContent.toe3 :
                  rearSliderValue == 100 ? toeContent.toe4 : null"
                >
              </div>
              <div class="toeTreadWear">
                <img :style="rearSliderValue > 60 ? null : 'transform: scaleX(-1)'"
                  :src="
                  rearSliderValue == 0 ? toeContent.toe4 :
                  rearSliderValue <= 20 ? toeContent.toe3 :
                  rearSliderValue <= 39 ? toeContent.toe2 :
                  rearSliderValue >= 40 && rearSliderValue <= 60 ? toeContent.tireImage :
                  rearSliderValue >= 61 && rearSliderValue <= 80 ? toeContent.toe2 :
                  rearSliderValue >= 81 && rearSliderValue <= 99 ? toeContent.toe3 :
                  rearSliderValue == 100 ? toeContent.toe4 : null"
                >
              </div>
            </div>
            <div class="lesschwabSliderContainer">
              <input type="range" @change="hidePopup" v-model.number="rearSliderValue" class="slider">
            </div>
            <div class="lesschwabSliderButton">
              <img class="sliderButtons" style="transform: scaleX(-1)" :src=" rearSliderValue >= 40 && rearSliderValue <= 60 ? toeContent.passImage : toeContent.failImage ">
              <div @click="decreaseRear()" class="increaseScale minus background-left left"></div>
              <div @click="increaseRear()" class="increaseScale plus background-right right"></div>
            </div>
            <h6>{{ toeContent.rearSlider }}</h6>
          </div>

        </div>
        <button @click="resetAll()" style="width: 100%;" class="button is-appointment-enabled" title="reset button">Reset</button>
      </div>

    </div>

  </div>

</template>

<script>
import Popup from "./Popup.vue";
import {ref} from "vue";

export default {
  name: 'PageCamber',
  props: ['toeContent'],
  components: {
    Popup
  },
  setup() {
    const isOpen = ref(false);
    return {isOpen};
  },
  data() {
    return {
      frontSliderValue: 50,
      rearSliderValue: 50,
      currentFrontStep: 4,
      maxFrontSteps: 7,
      currentRearStep: 4,
      maxRearSteps: 7,
      jumpSize: 10,
      show: true,
      showModal: false,
      showLines: false,
      popupText: "title",
      popupDefinition: "definition"
    };
  },
  watch: {
    frontSliderValue: function(value) {
      if(value === 0) {this.currentFrontStep = 1}
      if(value <= 20 && value >= 1) {this.currentFrontStep = 2}
      if(value <= 39 && value >= 21) {this.currentFrontStep = 3}
      if(value >= 40 && value <= 60) {this.currentFrontStep = 4}
      if(value >= 61 && value <= 80) {this.currentFrontStep = 5}
      if(value >= 81 && value <= 99) {this.currentFrontStep = 6}
      if(value === 100) {this.currentFrontStep = 7}
    },
    rearSliderValue: function(value) {
      if(value === 0) {this.currentRearStep = 1}
      if(value <= 20 && value >= 1) {this.currentRearStep = 2}
      if(value <= 39 && value >= 21) {this.currentRearStep = 3}
      if(value >= 40 && value <= 60) {this.currentRearStep = 4}
      if(value >= 61 && value <= 80) {this.currentRearStep = 5}
      if(value >= 81 && value <= 99) {this.currentRearStep = 6}
      if(value === 100) {this.currentRearStep = 7}
    },
  },
  methods: {
    hidePopup() {
      this.show = false;
    },
    resetAll() {
      this.frontSliderValue = 50;
      this.rearSliderValue = 50;
      this.show = true;
      this.jumpSize = 10;
    },
    increaseFront() {
      if(this.currentFrontStep === this.maxFrontSteps) { return; } else {
        this.currentFrontStep += 1;
        this.checkFrontLocation();
      }
    },
    decreaseFront() {
      if(this.currentFrontStep === 1) { return; } else {
        this.currentFrontStep -= 1;
        this.checkFrontLocation();
      }
    },
    checkFrontLocation() {
      if(this.currentFrontStep === 1) {this.frontSliderValue = 0}
      if(this.currentFrontStep === 2) {this.frontSliderValue = 20}
      if(this.currentFrontStep === 3) {this.frontSliderValue = 39}
      if(this.currentFrontStep === 4) {this.frontSliderValue = 50}
      if(this.currentFrontStep === 5) {this.frontSliderValue = 61}
      if(this.currentFrontStep === 6) {this.frontSliderValue = 81}
      if(this.currentFrontStep === 7) {this.frontSliderValue = 100}
    },
    increaseRear() {
      if(this.currentRearStep === this.maxRearSteps) { return; } else {
        this.currentRearStep += 1;
        this.checkRearLocation();
      }
    },
    decreaseRear() {
      if(this.currentRearStep === 1) { return; } else {
        this.currentRearStep -= 1;
        this.checkRearLocation();
      }
    },
    checkRearLocation() {
      if(this.currentRearStep === 1) {this.rearSliderValue = 0}
      if(this.currentRearStep === 2) {this.rearSliderValue = 20}
      if(this.currentRearStep === 3) {this.rearSliderValue = 39}
      if(this.currentRearStep === 4) {this.rearSliderValue = 50}
      if(this.currentRearStep === 5) {this.rearSliderValue = 61}
      if(this.currentRearStep === 6) {this.rearSliderValue = 81}
      if(this.currentRearStep === 7) {this.rearSliderValue = 100}
    },
  }
}
</script>

<style lang="scss">

.tireWear {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 10px;
  border-bottom: 8px solid black;
}

.toeTreadWear {
  height: 75px;
  width: 150px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
}

.toePage {
  margin-top: 50px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;

  @media(min-width: 768px) {
    flex-direction: row;
    align-items: none;
  }

  .toe-road {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .disclaimer {
    margin-top: 20px;
  }

  .tire {
    position: absolute;
    width: 15%;
    top: 0;
    z-index: 1;
  }

  .leftTires {
    left: 5%;
    height: 160px;
  }

  .rightTires {
    right: 5%;
    height: 160px;
  }

  .frontTires {
    position: absolute;
    width: 100%;
    margin: 0 auto;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .rearTires {
    position: absolute;
    width: 100%;
    margin: 0 auto;
    bottom: 45%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .car {
    z-index: 3;
  }

  .frontComponents {
    position: absolute;
    width: 65%;
    margin: 0 auto;
    top: 11%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .toe-10 {
    margin-top: 20px;
  }

  .toe-10 p{
    margin-bottom: 0;
  }

  .popupHandler {
    width: 100%;

    p{max-width: 300px; margin-bottom: 0;}
  }

  .header {
  margin-top: 0px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  @media(min-width: 992px) {
    margin-bottom: 0rem;
  }

  .introText {
    max-width: 450px;

    p {margin-bottom: 0;}
  }
}

}

.carDiagramToe {
  position: relative;
  margin-top: 2rem;
  height: auto;
}


.toe-left, .toe-right {

  width: calc(100% - 50px);

  @media(min-width: 480px) {
    width: calc(70% - 50px);
    //margin: 0 auto;
  }

  @media(min-width: 768px) {
    width: calc(50% - 50px);
   //margin: auto auto;
  }

  .button {
    text-align: center;
  }

}

.frontToe {
  //margin-top: 80px;
}

.rearToe {
  margin-top: 40px;
  margin-bottom: 50px;
}

.frontToe, .rearToe {

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h6 {
    margin: 0 auto;
    text-align: center;

    @media(min-width: 992px) {
      width: 70%;
    }
  }
}

.frontSlider, .rearSlider { width: 65%; margin: 0 auto; display: block; margin-bottom: 50px;}
.frontScale, .rearScale { padding: 10px; width: 100%; }
</style>
